import styled from "styled-components";
import { FaAngleDown, FaCircle } from "react-icons/fa";
import { FaPen } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaStickyNote } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaMailBulk } from "react-icons/fa";
import { FaPeopleArrows } from "react-icons/fa";
import { FaTh } from "react-icons/fa";
import { FaCopy } from "react-icons/fa";
import { FaCommentDots } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { FaQuestion } from "react-icons/fa";
import { Link } from "react-router-dom";

export const FiberManualRecordIcon = styled(FaCircle)`
  color: #62bd19;
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const CreateIcon = styled(FaPen)`
  font-size: 1.2rem;
`;

export const HomeIcon = styled(FaHome)`
  font-size: 1.2rem;
`;

export const NotesIcon = styled(FaStickyNote)`
  font-size: 1.2rem;
`;

export const DraftsIcon = styled(FaMailBulk)`
  font-size: 1.2rem;
`;

export const MailIcon = styled(FaEnvelope)`
  font-size: 1.2rem;
`;

export const PeopleAltIcon = styled(FaPeopleArrows)`
  font-size: 1.2rem;
`;

export const AppsIcon = styled(FaTh)`
  font-size: 1.2rem;
`;

export const FileCopyIcon = styled(FaCopy)`
  font-size: 1.2rem;
`;

export const FeedbackIcon = styled(FaCommentDots)`
  font-size: 1.2rem;
`;

export const ExpandLessIcon = styled(FaAngleUp)`
  font-size: 1.2rem;
`;

export const ExpandMoreIcon = styled(FaAngleDown)`
  font-size: 1.2rem;
`;

export const AddIcon = styled(FaPlus)`
  font-size: 1.2rem;
`;

export const Avatar = styled.img`
  border-radius: 50%;
  height: 50px;
  cursor: pointer;
`;

export const Main = styled.section`
  display: flex;
`;

export const SidebarContainer = styled.aside`
  color: white;
  z-index: 99;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  width: 20%;
  position: fixed;
  top: 0;
  backdrop-filter: blur(16px) saturate(180%);
  transition: ease 0.3s;
  left: ${({ sidebarOpen }) => (sidebarOpen ? 0 : "-100%")};
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 20px -2px black;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 1024px) {
    width: 40%;
  }
  @media screen and (max-width: 400px) {
    width: 100%;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.813rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
`;

export const SidebarOptionMenu = styled.div`
  display: ${({ sidebarOptionMenuOpen }) =>
    sidebarOptionMenuOpen ? "block" : "none"};
`;

export const SidebarInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
`;

export const ShowLessButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  cursor: pointer;
  &:hover {
    background: rgba(155, 155, 155, 0.1);
  }

  & span {
    font-weight: 500;
  }
`;

export const SidebarMain = styled.div`
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  width: 100%;
  padding: 1rem 0;
  position: absolute;
`;

export const AvatarContainer = styled.div`
  display: flex;
  position: relative;
`;

export const SidebarLogOut = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.06);
  box-shadow: 20px 20px 22px rgba(0, 0, 0, 0.2);
`;

export const Icon = styled.i`
  padding: 0.3rem;
  color: #5c5c5c;
  font-size: 1.125rem;
  background-color: rgb(12, 12, 12);
  border-radius: 62.438rem;
  font-size: 1.1rem;
`;

export const SidebarUserName = styled.div`
  color: #fff;
  font-size: 1.2rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoutButton = styled.button`
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.06);
  color: #fff;
  text-align: center;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
  transition: 0.5s;

  &:after {
    content: "»";
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0.5s;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);

    padding-right: 24px;
    padding-left: 8px;
  }
  &:hover:after {
    opacity: 1;
    right: 10px;
  }
  border: none;
  outline: none;
`;

export const HelpOutlineIcon = styled(FaQuestion)`
  font-size: 1.2rem;
  color: #111;
  display: flex;
`;

export const SidebarLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: 1px solid rgba(155, 155, 155, 0.3);
  margin: 1rem;
  border-radius: 5px;
  text-decoration: none;
  color: #fff;

  & h3 {
    display: flex;
    align-items: center;
    font-weight: 500;
    padding-left: 0.938rem;
    font-size: 1.125rem;
  }

  &:hover {
    background: rgba(155, 155, 155, 0.1);
  }
`;
